var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDistance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 23,
    viewBox: "0 0 34 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5856 19.8439L25.3948 1.09395C25.1036 0.427148 24.469 0 23.7706 0H18.0524L18.196 1.35703C18.2253 1.63359 18.0079 1.875 17.7296 1.875H16.021C15.7427 1.875 15.5253 1.63359 15.5546 1.35703L15.6981 0H9.97995C9.28093 0 8.64636 0.427148 8.35515 1.09395L0.164329 19.8439C-0.377663 21.0855 0.487181 22.5 1.78972 22.5H13.3233L13.9274 16.7766C13.9778 16.2996 14.3798 15.9375 14.8596 15.9375H18.8909C19.3708 15.9375 19.7727 16.2996 19.8231 16.7766L20.4272 22.5H31.9608C33.2634 22.5 34.1282 21.0855 33.5856 19.8439ZM15.2581 4.16953C15.2702 4.05433 15.3246 3.94771 15.4108 3.87024C15.4969 3.79277 15.6086 3.74994 15.7245 3.75H18.0266C18.2663 3.75 18.4678 3.93105 18.493 4.16953L18.7626 6.72305C18.8065 7.13848 18.4807 7.5 18.0635 7.5H15.6882C15.2704 7.5 14.9452 7.13848 14.9891 6.72305L15.2581 4.16953ZM18.4948 14.0625H15.2551C14.6985 14.0625 14.2643 13.5803 14.3229 13.0266L14.62 10.2141C14.6704 9.73711 15.0723 9.375 15.5522 9.375H18.1977C18.6776 9.375 19.0796 9.73711 19.13 10.2141L19.427 13.0266C19.4856 13.5803 19.0514 14.0625 18.4948 14.0625Z",
    fill: "#8E8E8E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDistance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/distance.acf9c4ca3112e37c78fe27d960f27eee.svg";